export const AttendenceIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="#ffc327"
    stroke="#ffc327"
    strokeWidth="0"
    viewBox="0 0 24 24"
  >
    <path fill="none" stroke="none" d="M0 0h24v24H0z"></path>
    <path
      stroke="none"
      d="M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62"
    ></path>
    <circle cx="9" cy="13" r="1" stroke="none"></circle>
    <circle cx="15" cy="13" r="1" stroke="none"></circle>
    <path
      stroke="none"
      d="M18 11.03A6.04 6.04 0 0 0 12.05 6c-3.03 0-6.29 2.51-6.03 6.45a8.07 8.07 0 0 0 4.86-5.89c1.31 2.63 4 4.44 7.12 4.47"
    ></path>
  </svg>
);

export const ClockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill="#FF8F6B"
      stroke="#FF8F6B"
      strokeWidth="1.5"
      d="M9 16.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
    ></path>
    <path
      stroke="#FF8F6B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M10.5 1.5h-3M9 1.5v3M13.125 6l1.125-1.125"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M9 10.5V8.25M9 10.5H6.75"
    ></path>
  </svg>
);

export const GraphIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="#5B93FF"
    stroke="#5B93FF"
    strokeWidth="0"
    viewBox="0 0 16 16"
  >
    <path stroke="none" d="M15 13v1H1.5l-.5-.5V0h1v13z"></path>
    <path
      stroke="none"
      d="M13 3.207 7.854 8.354h-.708L5.5 6.707l-3.646 3.647-.708-.708 4-4h.708L7.5 7.293l5.146-5.147h.707l2 2-.707.708z"
    ></path>
  </svg>
);